import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getDossierSubTypeByOu from '../../services/dossierType/getDossierSubTypeByOu'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchSearchDossierSubType () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const searchDossierSubtypesCombo = yield call(getDossierSubTypeByOu, auth.token)
    yield put(fetchCombosSuccess({ searchDossierSubtypesCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchSearchDossierSubType () {
  yield takeLatest(combosActionTypes.FETCH_SEARCH_DOSSIER_SUBTYPES, fetchSearchDossierSubType)
}
